import React from 'react'

import { strings } from '../../../lib/localization'
import { BreadcrumbItem, Breadcrumbs } from './breadcrumbs'

export const ArticleDetailsBreadcrumbs = ({
  article,
  answersId,
  faqAPIVersion,
}) => {
  const breadcrumbs: BreadcrumbItem[] = [
    {
      type: 'start',
      label: strings.answersBreadcrumbHome,
      navigationParams: {},
    },
  ]

  if (article.qCat) {
    breadcrumbs.push({
      type: 'answersCategory',
      label: article.qCat,
      navigationParams: {
        userId: article.sid,
        answersId,
        categoryId: article.qCatId,
        categoryName: article.qCat,
        faqAPIVersion,
      },
    })
  }

  breadcrumbs.push({
    type: 'answersDetails',
    label: strings.answersBreadcrumbArticle,
    navigationParams: {
      userId: article.sid,
      answersId,
      articleId: article.id,
      faqAPIVersion,
    },
  })

  return <Breadcrumbs breadcrumbs={breadcrumbs} />
}
